import { render, staticRenderFns } from "./ContractView.vue?vue&type=template&id=6621493e&scoped=true"
import script from "./ContractView.vue?vue&type=script&lang=js"
export * from "./ContractView.vue?vue&type=script&lang=js"
import style0 from "./ContractView.vue?vue&type=style&index=0&id=6621493e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6621493e",
  null
  
)

export default component.exports